import React from 'react';
import Icon from 'components/atoms/Icon';
import { ErrorMessage as ErrorMessageType } from 'types/chat.types';

interface ErrorMessageDisplayProps {
  message: ErrorMessageType;
}

const ErrorMessageDisplay: React.FC<ErrorMessageDisplayProps> = ({ message }) => {
  const { content, error, timestamp } = message;

  return (
    <div className="self-start flex flex-col">
      <div className="bg-red-50 border border-red-200 px-4 py-3 rounded-2xl rounded-bl-md max-w-2xl">
        <div className="flex items-center gap-2 mb-2">
          <div className="w-5 h-5 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
            <Icon name="alert" className="w-3 h-3 text-red-600" />
          </div>
          <span className="text-sm font-semibold text-red-800">Error</span>
        </div>
        <div className="text-sm text-red-700">{content || error}</div>
      </div>
      <div className="text-xs text-gray-400 mt-1 ml-2">
        {timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
      </div>
    </div>
  );
};

export default ErrorMessageDisplay;
